import Vue from 'vue';
import store from '../indexes/store';
import App from '../indexes/pages/index-shops.vue';

export default function () {
    const app = new Vue({ // eslint-disable-line no-unused-vars
        el: '#app-shops-product',
        store,
        render: (h) => h(App),
    });
}
